export default __webpack_public_path__ + "img/9ea0d52e058eef02e16eff0ffb326f1f.png";